import { Link } from "react-router-dom";
import "./Welcome.css";

function Welcome() {
  return (
    <div className="welcome-container">
      <main className="welcome-main">
        <section className="hero-section">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">Create Intelligent Forms with Kedo Forms</h1>

              <p className="hero-description">
                Kedo Forms, powered by Xlab B.V., simplifies the creation of customized digital forms
                designed to optimize data collection and improve the efficiency of your processes. Our
                intuitive platform allows you to design, manage, and automate forms tailored to your
                organization's specific needs, without requiring advanced technical knowledge.
              </p>

              <div className="features-list">
                <h3>With modern and flexible tools, you can:</h3>
                <ul>
                  <li>Design dynamic forms with conditional logic</li>
                  <li>Customize fields, styles, and structure</li>
                  <li>Integrate with internal systems and external applications</li>
                  <li>Collect and analyze data in real-time</li>
                  <li>Ensure security and regulatory compliance</li>
                </ul>
              </div>

              <p className="hero-closing">
                Whether for registrations, surveys, internal requests, or business processes,
                Kedo Forms offers you a secure, scalable, and easy-to-use solution.
              </p>

              <p className="hero-cta-text">
                Transform the way you capture information and take your processes to the next level.
              </p>
            </div>

            <div className="hero-visual">
              <div className="form-icon-container">
                <div className="form-icon">📋</div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="welcome-footer">
        <p>&copy; 2025 Xlab B.V. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Welcome;
